export const NUX_MODAL_SEEN = 'supper_NUX_MODAL_SEEN';
export const MAX_MATCH_SCORE = 0.75;
